import React from "react";
import "../styles/RegiserStyles.css";
import { Form, Input, message } from "antd";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../redux/features/alertSlice";
const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //form handler
  const onfinishHandler = async (values) => {
    try {
      dispatch(showLoading());
      const res = await axios.post("https://doctor-appointment-booking-mern-app.vercel.app/api/v1/user/register", values);
      dispatch(hideLoading());
      if (res.data.success) {
        message.success("Register Successfully!");
        navigate("/login");
      } else {
        message.error(res.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      message.error("Something Went Wrong");
    }
  };
  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      +91
    </Form.Item>
  );
  return (
    <>
      <div className="form-container ">
        <Form
          layout="vertical"
          onFinish={onfinishHandler}
          className="register-form"
        >
          <h3 className="text-center">Register From</h3>
          <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please input your Name!' }]}>
            <Input type="text" placeholder="your name" required />
          </Form.Item>
          <Form.Item label="Email" name="email" rules={[{ required: true, message: 'Please input your Email!' }]}>
            <Input type="email" placeholder="your email" required />
          </Form.Item>
          <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Please input your password!' }]}>
            <Input type="password" placeholder="******" min={6} required />
          </Form.Item>
          <Form.Item
            name="phone"
            label="Phone Number"
          >
            <Input addonBefore={prefixSelector} style={{ width: '100%' }} placeholder="XXXXXXXXXX" min={10} />
          </Form.Item>
          <Form.Item label="Address" name="address">
            <Input type="text" placeholder="your address" />
          </Form.Item>
          <Link to="/login" className="m-2">
            Already user login here
          </Link>
          <button className="btn btn-primary" type="submit">
            Register
          </button>
        </Form>
      </div>
    </>
  );
};

export default Register;
